import React, { Component } from "react";
import Header from "../../components/header/Header";
import { dataai, fulls } from "../../portfolio.js";
import { handleLandingScroll } from "../../utils/scroll";
import { trackPageview } from "../../utils/analytics";

function pad(n) { return n < 10 ? "0" + n : "" + n; }

function ProjectRow({ id, item }) {
  const techs = (item.languages || []).map((l) => l.name);
  return (
    <div className="proj">
      <div className="num">{id}</div>
      <div>
        <div className="name">{item.name}</div>
        <div className="desc">{item.description}</div>
      </div>
      <div className="tech">
        {techs.map((t) => <span key={t}>{t.toLowerCase()}</span>)}
      </div>
      <div className="stat">
        <span className="yr">{item.year || "—"}</span>
        <span className="done">SHIPPED</span>
      </div>
    </div>
  );
}

class Projects extends Component {
  componentDidMount() {
    handleLandingScroll(this.props.location);
    trackPageview();
  }
  render() {
    const ai = dataai.data || [];
    const fs = fulls.data || [];

    // show every project in portfolio.js, sorted newest-first
    const all = [...ai, ...fs].sort((a, b) => {
      const ya = a.year || 0;
      const yb = b.year || 0;
      if (yb !== ya) return yb - ya;
      return (b.createdAt || "").localeCompare(a.createdAt || "");
    });

    const total = all.length;
    const newest = all[0]?.year || 2026;
    const oldest = all[all.length - 1]?.year || 2019;

    // CAREER TOTALS — hardcoded, separate from what's shown above
    const careerScraping = 153;
    const careerFullStack = 6;
    const careerBlockchain = 7;
    const careerTotal = careerScraping + careerFullStack + careerBlockchain;

    return (
      <>
        <div className="grid-bg" />
        <Header theme={this.props.theme} />

        <div className="wrap">

          {/* HERO */}
          <section className="hero">
            <div className="label-strip">
              <span><b>THE CATALOGUE</b></span>
              <span>{pad(total)} SHOWN · {careerTotal} SHIPPED</span>
              <span><b>{oldest}</b> → {newest}</span>
            </div>

            <h1 className="huge">
              <span className="row">THE</span>
              <span className="row indent"><span className="ital">work.</span></span>
            </h1>

            <div className="sub-row">
              <p>
                Most of these started as a client's specific problem and ended
                as something <b>more general</b>. Short descriptions on
                purpose — happy to go deeper on a call.
              </p>
              <div className="meta-block">
                <div className="k">BREAKDOWN</div>
                <div className="row"><span className="lab">SCRAPING / AI</span><span>{careerScraping}</span></div>
                <div className="row"><span className="lab">FULL STACK</span><span>{pad(careerFullStack)}</span></div>
                <div className="row"><span className="lab">BLOCKCHAIN</span><span>{pad(careerBlockchain)}</span></div>
                <div className="row"><span className="lab">SHOWN HERE</span><span>{pad(total)}</span></div>
                <div className="row"><span className="lab">TOTAL SHIPPED</span><span>{careerTotal}</span></div>
              </div>
            </div>
          </section>

          {/* ALL PROJECTS — sorted newest first */}
          <section className="section" id="catalogue">
            <div className="section-head">
              <h2 className="section-title">ALL <em>·</em> NEWEST FIRST</h2>
              <div className="meta"><b>{pad(total)}</b> / {careerTotal}<br/>SHOWN</div>
            </div>

            <div className="proj-list">
              {all.map((item, i) => (
                <ProjectRow key={item.id || item.name + i} id={pad(i + 1)} item={item} />
              ))}
            </div>
          </section>

          <p style={{ marginTop: 32, fontFamily: "'JetBrains Mono', monospace", fontSize: 12, textTransform: "uppercase", letterSpacing: ".06em", textAlign: "center", padding: "0 0 32px" }}>
            <a className="inline" href="https://github.com/walidMaaninou">→ MORE ON GITHUB</a> · <a className="inline" href="#/contact?to=channels">→ ASK ABOUT NDA WORK</a>
          </p>
        </div>

        {/* CONTACT SLAB */}
        <div className="wrap">
          <div className="foot-slab">
            <div className="inner">
              <h2>SEE SOMETHING <em>useful?</em><br/>LET'S BUILD.</h2>
              <div>
                <p>Available on LinkedIn and Gmail — reply within 24 hours.</p>
                <div className="links">
                  <a href="mailto:maaninou.walid@gmail.com">→ EMAIL <span>MAANINOU.WALID@GMAIL.COM</span></a>
                  <a href="https://github.com/walidMaaninou">→ GITHUB <span>@WALIDMAANINOU</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="site-footer">
          <span>© 2026 MAANINOU WALID · CASABLANCA · GMT+1</span>
          <span>
            <a href="mailto:maaninou.walid@gmail.com">EMAIL</a>
            <a href="https://github.com/walidMaaninou">GITHUB</a>
            <a href="https://www.linkedin.com/in/walid-maaninou-86a844102/">LINKEDIN</a>
          </span>
        </footer>
      </>
    );
  }
}

export default Projects;
